import React from 'react'
import {Tag} from "antd";


const TagsStatus = ({record}) => {

    const statuses = {
        'COMPLETED': {
            text: 'Tamamlandı',
            color: 'success'
        },
        'WAITING': {
            text: 'Bekliyor',
            color: 'warning'
        }
    }

    return(
        <React.Fragment>
            {Object.keys(statuses).map(key => {
                if (record === key){
                    return <Tag key={key} color={statuses[key].color} >{statuses[key].text}</Tag>
                }
            })}
        </React.Fragment>
    )
}
export default TagsStatus